import { isDisabledGeoblock } from '#/config/environments';
import { useSelector } from '#/reduxState/store';

/**
 * This value indicates whether the user is in a restricted region
 * which does not allow them to trade or deposit when any value other
 * than false. The value will be the region name when they are restricted
 * which is utilized to render the region they are in as-needed within the UI.
 *
 * See `isDisabledGeoblock` for ways how to work with geo-whitelisted wallets.
 */
export function useIsRestrictedRegion() {
  const isRestrictedRegion = useSelector(
    state => state.region.restrictedRegion
  );
  if (isDisabledGeoblock) {
    return false;
  }
  return typeof isRestrictedRegion === 'string';
}
